<template>
  <iframe :src="`https://www.youtube.com/embed/${videoId}`"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
          frameborder="0"
          referrerpolicy="strict-origin-when-cross-origin"
          title="YouTube video player">
  </iframe>
</template>

<script lang="ts" setup>
const {videoId} = defineProps<{
    videoId: string;
}>();
</script>